import { Component } from '@angular/core';
import { UserNotesComponent } from '@zero/shared/ui-web-components';
import { FaqHintComponent } from '../../components/faq-hint/faq-hint.component';
import { TicketListComponent } from '../../components/ticket-list/ticket-list.component';

@Component({
  templateUrl: './ticket-page.component.html',
  imports: [UserNotesComponent, FaqHintComponent, TicketListComponent],
})
export class TicketPageComponent {}
